export var fnoBanMapper = function (data) {
    var _a, _b, _c, _d, _e, _f;
    var mapperData = {
        securities: {
            stockList: dataMapper((_a = data === null || data === void 0 ? void 0 : data.securities) !== null && _a !== void 0 ? _a : []),
            asOnDate: (_b = data === null || data === void 0 ? void 0 : data.asOnDate) !== null && _b !== void 0 ? _b : "",
        },
        possibleEntrance: {
            stockList: dataMapper((_c = data === null || data === void 0 ? void 0 : data.possibleEntrance) !== null && _c !== void 0 ? _c : []),
            asOnDate: (_d = data === null || data === void 0 ? void 0 : data.asOnDate) !== null && _d !== void 0 ? _d : "",
        },
        possibleExits: {
            stockList: dataMapper((_e = data === null || data === void 0 ? void 0 : data.possibleExits) !== null && _e !== void 0 ? _e : []),
            asOnDate: (_f = data === null || data === void 0 ? void 0 : data.asOnDate) !== null && _f !== void 0 ? _f : "",
        },
    };
    function dataMapper(data) {
        return data.map(function (item) {
            return {
                displayName: item.dpName,
                previousMWPL: item.previousMWPL,
                currentMWPL: item.currentMWPL,
                sym: item.sym
            };
        });
    }
    return mapperData;
};
